import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { BrowserRouter } from 'react-router-dom'
import './styles/design.css'

import { dpyTheme } from './theme'
import { loadConfig } from './config'
import { initApi } from './api/http'
import { AuthProvider } from './auth/AuthContext'
import { NotificationProvider } from './components/Notifications'
import App from './App'

// Cargamos config runtime ANTES de montar la app (define apiBase y branding).
loadConfig().then(() => {
  initApi()
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <ThemeProvider theme={dpyTheme}>
        <CssBaseline />
        <BrowserRouter>
          <NotificationProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </NotificationProvider>
        </BrowserRouter>
      </ThemeProvider>
    </React.StrictMode>,
  )
})
